module.exports = __webpack_public_path__ + "img/recommend-icon.8a965734.svg";